import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { defaultFeedbackToastComponentProps } from "../cubeComponent/constants";
import type { TranslatedString } from "@i18n";

/**
 * Toast notification payload type.
 * The `content` field requires a TranslatedString to ensure all messages are internationalized.
 * Use the `t()` function from @i18n to create translated content.
 *
 * @example
 * import { t } from "@i18n";
 * dispatch(showToastNotification({ content: t("success.message"), type: "success" }));
 */
export interface ToastNotificationPayload {
  content: TranslatedString;
  type?: string;
  title?: string;
  timeOut?: number;
  isActionButton?: boolean;
  actionBtnText?: string;
  onActionBtnClick?: () => void;
  position?: {
    X: string;
    Y: string;
  };
}

export interface ToastNotificationState extends Partial<ToastNotificationPayload> {}

const toastSlice = createSlice({
  name: "toastNotificationContent",
  initialState: {} as ToastNotificationState,
  reducers: {
    setToastNotification: (_state: ToastNotificationState, action: PayloadAction<ToastNotificationPayload>) =>
      action.payload && action.payload.content ? { ...defaultFeedbackToastComponentProps, ...action.payload } : {},
  },
});

export const { setToastNotification } = toastSlice.actions;
export const showToastNotification = setToastNotification;
export default toastSlice.reducer;
